module.exports = __webpack_public_path__ + "static/media/IB_process.cf1e9223.png";